export const checkCents = (text) => {
    let result = text;
    if (text === '')
        return '00';
    if (text.length === 1) {
        result += '0';
    }
    return result;
};
//# sourceMappingURL=PriceHelpers.js.map